const SHELF_TYPE_MARGIN_X = { displayFridge: 110, airCurtainFridge: 85 }

export const calcHeatmapProps = ({
  shelfId,
  shelfType,
  shelfViewMode,
  shelfAnswer,
  imageWidth,
  imageHeight,
  fullscreenScale = 1
}) => {
  const heatmap = shelfAnswer?.shelftestHeatmap
  const useByPolygons = shelfViewMode !== 'heatmap'
  const marginX = SHELF_TYPE_MARGIN_X[shelfType] ?? 50

  return {
    heatmap: heatmap
      ? {
          levels: useByPolygons ? heatmap.levels_by_polygons : heatmap.levels,
          contours: useByPolygons ? heatmap.contours_by_polygons : heatmap.contours,
          points: heatmap.points
        }
      : null,
    width: imageWidth * fullscreenScale - marginX,
    height: imageHeight,
    id: shelfId,
    mode: shelfViewMode
  }
}
